import { onError } from '@apollo/client/link/error'

import { noty } from 'Utils'

const formatGraphQLErrorMessage = (message: string): string => {
  if (!message) return 'Something went wrong'

  const extractedMessage = /message:\s*"([^"]+)"/.exec(message)?.[1]
  if (extractedMessage) return extractedMessage

  return message
}

const errorLink = onError(({ graphQLErrors }) =>
  graphQLErrors?.forEach(({ message }) => noty(formatGraphQLErrorMessage(message))),
)

export default errorLink
